import React, {Component} from 'react';
import {Spin} from 'antd';
import {api, app, config} from "../app";
import utils from "../utils";
import cardImg from "../assets/cardImg.png";

class CardCanvas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInfo: {},
            loading: true,
            canvasId: "card-canvas-" + props.id,
        };
    }

    /**
     * 数据
     * @param mall_id
     */
    dataSource = async () => {
        try {
            let {other} = this.props, params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                indexno_card: this.props.indexno,
            };
            if (other) params = Object.assign(params, other);
            let {flag, data, msg} = await app.post(api.CardDetails, params);
            if (flag === 1) {
                await this.drawCanvas(data);
            } else {
                app.alert(msg, 'warn');
                this.setData({loading: false});
            }
        } catch (e) {
            console.error(e);
            this.setData({loading: false});
        }
    }

    /**
     * 开始画板
     * @param id
     */
    drawCanvas = async (dataInfo) => {
        const {canvasId} = this.state;
        const canvas = document.getElementById(canvasId);
        const ctx = canvas.getContext("2d");
        const bgImg = await utils.imageLoad(ctx, cardImg);
        ctx.drawImage(bgImg, 0, 0);
        const localpath = dataInfo.localpath;
        if (localpath) {
            const headImg = await utils.imageLoad(ctx, config.imgUrl + localpath, 81, 115);
            if (headImg) ctx.drawImage(headImg, 25, 84, 81, 114);
        }
        ctx.font = "bold 11px 微软雅黑";
        ctx.fillText(`${dataInfo.vname}/${dataInfo.pinyin}`, 117, 110);     //姓名
        ctx.fillText(dataInfo.teampositionname || '无', 117, 145);     //职位
        ctx.fillText(dataInfo.teamname || '无', 117, 180);     //所属分队
        ctx.fillText(dataInfo.bsrno || '无', 175, 197);     //编号
        ctx.fillText(dataInfo.nickname || '无', 525, 86);     //代号
        ctx.fillText(dataInfo.idno || '无', 531, 110);     //身份识别ID
        ctx.fillText(dataInfo.passport || '无', 569, 132);     //护照号
        ctx.fillText(dataInfo.bloodtype || '无', 550, 152);     //血型
        // ctx.fillText(dataInfo.medicalhis || '无', 468, 157);     //重大医疗史
        ctx.fillText(dataInfo.drughis || '无', 466, 188);        //药物过敏史
        ctx.fillText(dataInfo.emecontact || '无', 466, 213);     //紧急联系人
        ctx.fillText(dataInfo.emecontactphone || '无', 466, 239);    //紧急联系电话
        this.setData({loading: false});
    }

    /**
     * 设置值
     * @param obj
     */
    setData = (obj, cb) => {
        if (this._isMounted) {
            this.setState(obj, () => {
                if (cb) cb();
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setData({
            loading: true,
            indexno: nextProps.indexno,
        }, async () => {
            await this.dataSource();
        });
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.dataSource();

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {loading, canvasId} = this.state;
        return (
            <div className="card-canvas" style={{width: 969, height: 288, textAlign: "center"}}>
                <canvas id={canvasId} width="969" height="288" hidden={loading}/>
                <Spin size="large" hidden={!loading}/>
            </div>
        );
    }
}

export default CardCanvas;



// WEBPACK FOOTER //
// ./src/components/CardCanvas.jsx